import { Injectable } from '@angular/core';
import { FeatureFlagEnum } from '../models/feature-flag.model';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class FeatureFlagEventBus {
  #flagEvaluationSubject = new Subject<{ flag: FeatureFlagEnum; value: boolean }>();
  #evaluatedFlags = new Set<FeatureFlagEnum>();

  flagEvaluations$ = this.#flagEvaluationSubject.asObservable();

  broadcastFlagEvaluation(flag: FeatureFlagEnum, value: boolean): void {
    if (!this.#evaluatedFlags.has(flag)) {
      this.#flagEvaluationSubject.next({ flag, value });
      this.#evaluatedFlags.add(flag);
    }
  }
}
